var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.6,
    viewBox: "0 0 12 12.6",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(34,34,34,0.8)",
    d: "M2.12 6.642a.6.6 0 1 1 .44 1.116 2.147 2.147 0 0 0-1.36 2V10.8a.6.6 0 0 0 .6.6h4.8a.6.6 0 0 0 .6-.6v-.988A2.195 2.195 0 0 0 5.786 7.76a.6.6 0 1 1 .428-1.12A3.4 3.4 0 0 1 8.4 9.812v.988a1.8 1.8 0 0 1-1.8 1.8H1.8A1.8 1.8 0 0 1 0 10.8V9.756a3.347 3.347 0 0 1 2.12-3.114zM4.2.6A2.4 2.4 0 0 1 6.6 3v1.2a2.4 2.4 0 0 1-4.8 0V3A2.4 2.4 0 0 1 4.2.6zm0 1.2A1.2 1.2 0 0 0 3 3v1.2a1.2 1.2 0 0 0 2.4 0V3a1.2 1.2 0 0 0-1.2-1.2zM9.6 12a.6.6 0 0 1 0-1.2h.6a.6.6 0 0 0 .6-.6V9.1a2.032 2.032 0 0 0-1.389-1.931.6.6 0 1 1 .379-1.138A3.232 3.232 0 0 1 12 9.1v1.1a1.8 1.8 0 0 1-1.8 1.8zM7.8 1.2a.6.6 0 1 1 0-1.2 2.4 2.4 0 0 1 2.4 2.4v1.2A2.4 2.4 0 0 1 7.8 6a.6.6 0 1 1 0-1.2A1.2 1.2 0 0 0 9 3.6V2.4a1.2 1.2 0 0 0-1.2-1.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users.e6085561ca54e570849f7751918caa5e.svg";